<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xlQa2l/tc-custom/9781466842151.jpg?1732052124261" alt="This image is the cover for the book Guilty Knowledge"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Guilty Knowledge
      </h1>
      <p class="bookDescription body article font2">
        <p><b>"With hard-hitting prose and clipped dialogue, this enjoyable thriller boasts a snappy authenticity, a Don Juan/James Bond barrister and a timely, jaunty mix of sex and politics." —<i>Publishers Weekly</i></b><br/><br/> The first female president of the United States? Alison Bowman has what it take—intelligence, political savvy, grace, unstained character. Almost. Because now, at the height of her career, she is being blackmailed. A lurid videotape of Alison in a stateroom of a cruise ship proves that she had an affair. The blackmailer is threatening to show it to her political enemies.<br/><br/> Washington lawyer Steve Bentley agrees to help Alison get the blackmailer off her back--but before he can act, the predator is killed. Steve is forced to do a clean-up job that leaves him racked with suspicion and guilty knowledge, making Steve a pawn in a game whose players will commit any act in order to win, whether it be blackmail, perjury—or murder. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        E. Howard Hunt
      </h2>
      
      <p class="authorDescription body article"><P><B>E. Howard Hunt </B>has been a correspondent for <I>Life</I> magazine in the South Pacific, an Army Air Corps pilot, a guerrilla fighter in China behind enemy lines during World War II, and an agent in the Office of Strategic Services.  He spent twenty-one years in the CIA, mostly as a spy in Latin America.  Howard Hunt is the author of more than seventy novels and lives in Miami, Florida.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      A Tom Doherty Associates Book
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?cd80b78c